import { styled } from '@mui/system'

export const EventsImagesContainer = styled('div')(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    margin: '30px 0',
  },
}))

export const BackgroundImageLeft = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '25%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  height: '60%',
  maxWidth: '35vw',
  objectFit: 'cover',
  border: '10px solid #ccc',
  boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
  zIndex: 0,
  [theme.breakpoints.down('md')]: {
    position: 'static',
    transform: 'none',
    width: '40%',
    maxWidth: '350px',
    height: 'auto',
  },
}))

export const BackgroundImageRight = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  right: '25%',
  transform: 'translate(50%, -50%)',
  width: 'auto',
  height: '60%',
  maxWidth: '35vw',
  objectFit: 'cover',
  border: '10px solid #ccc',
  boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
  zIndex: 0,
  [theme.breakpoints.down('md')]: {
    position: 'static',
    transform: 'none',
    width: '40%',
    maxWidth: '350px',
    height: 'auto',
  },
}))
